import { Component, Mixins } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import PatientMixin from "@/mixins/patientMixin";
import UtilMixin from "@/mixins/utilMixin";

/** 記録書Ⅲ 一覧の項目 */
export interface Record3ListItem {
  id: number;
  patient_id: number;
  target_date: string; // YYYY-MM-DD
  target_date_wareki: string; // 令和8年8月25日
  visit_record_count: number;
  first_staff_name: string;
  created_at: string;
  updated_at: string; // YYYY-MM-DD HH:MM:SS
}

@Component
export default class BaseRecord3List extends Mixins(
  AxiosMixin,
  UtilMixin,
  PatientMixin
) {
  protected records: Record3ListItem[] = [];
  protected totalCount = 0;
  protected page = 1;
  protected limit = 20;

  //  一覧取得（page=1のときは置き換え、それ以外は末尾に追加させる）
  protected fetchRecord3(
    patientId: number,
    onLoaded?: (fetchedCount: number) => void
  ): void {
    this.postJsonCheck(
      window.base_url + "/api/patient/visitrecord3s/get",
      {
        patient_id: patientId,
        yearmonth: 0,
        page: this.page,
        limit: this.limit
      },
      res => {
        const fetched: Record3ListItem[] = res.data.records ?? [];
        if (this.page === 1) {
          this.records = fetched;
        } else {
          this.records = this.records.concat(fetched);
        }
        this.totalCount = res.data.total_count ?? 0;
        if (onLoaded) onLoaded(fetched.length);
      }
    );
  }

  /** 一覧状態のリセット */
  protected resetRecord3List(): void {
    this.records = [];
    this.totalCount = 0;
    this.page = 1;
  }

  /** PDFを表示する */
  protected pdfRecord3(item: Record3ListItem): void {
    this.makePdf(window.base_url + "/api/patient/visitrecord3/preview", {
      id: item.id
    });
  }
}
